/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";
import { NbMenuService } from "@nebular/theme";

@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  constructor(private menuService: NbMenuService) {}

  ngOnInit(): void {}

  onContecxtItemSelection(title) {
    if (title === "Log out") {
      localStorage.removeItem("auth_app_token");
    }
  }
}
